<template><div><h1 id="_6-mailchimp-e-mail" tabindex="-1"><a class="header-anchor" href="#_6-mailchimp-e-mail"><span>6. MailChimp (E-Mail)</span></a></h1>
<p>Für das E-Mail Marketing- und Newsletter-Tool MailChimp bietet funtrade eine Schnittstelle für den Austausch der Daten an. Die Kampagne (Newsletter) wird wie gewohnt in MailChimp erfasst und mit einer Mailingliste verknüpft. Der Rest wie z.B. die Selektion der Empfänger und der Versand (inkl. Test-Versand) wird in funtrade vorgenommen. Sowohl der Versand als auch die Bounces/Retouren (z.B. unzustellbar oder Abmeldungen) werden in Form von Ereignissen bei den entsprechenden Personen als Kontaktgeschichte vermerkt.</p>
<p>In der Kampagne können auch Platzhalter definiert werden, die ein Datenbankfeld in funtrade referenzieren (z.B. Anrede, Spendenbetrag, etc.).</p>
<h3 id="_6-1-parametrisierung" tabindex="-1"><a class="header-anchor" href="#_6-1-parametrisierung"><span>6.1. Parametrisierung</span></a></h3>
<p>Nachfolgende Einstellungen müssen vorgängig vorgenommen werden, damit die Schnittstelle verwendet werden kann.</p>
<h4 id="_6-1-1-api-schlussel" tabindex="-1"><a class="header-anchor" href="#_6-1-1-api-schlussel"><span>6.1.1. API-Schlüssel</span></a></h4>
<p>Der API-Schlüssel wird in der Site-Configuration definiert.</p>
<div class="language-properties line-numbers-mode" data-highlighter="prismjs" data-ext="properties"><pre v-pre><code><span class="line"><span class="token key attr-name">&lt;property</span> <span class="token value attr-value">name="mailchimp.apikey">7e82977c93e8d564a00f4b8f281b4c27-us14&lt;/property></span></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div></div></div><h4 id="_6-1-2-exportformat" tabindex="-1"><a class="header-anchor" href="#_6-1-2-exportformat"><span>6.1.2. Exportformat</span></a></h4>
<p>Für den Export der Daten aus funtrade zu MailChimp wird ein Exportformat mit der Bezeichnung &quot;MailChimp&quot; verwendet. Dieser sollte die Exportfelder welche für MailChimp relevant sind enthalten (z.B. Vorname, Name, E-Mail Adresse, etc.).</p>
<h3 id="_6-2-beschreibung-des-ablaufs" tabindex="-1"><a class="header-anchor" href="#_6-2-beschreibung-des-ablaufs"><span>6.2. Beschreibung des Ablaufs</span></a></h3>
<p>In MailChimp wird bis auf das Hinzufügen von Empfängern alles soweit erfasst und für den Versand vorbereitet.</p>
<p>In funtrade unter Datenaustausch/MailChimp erscheinen die vorbereiteten Kampagnen.</p>
<p>Zu den Kampagnen können nun die Empfänger über Personenfilter oder Segmentierung zugeordnet werden.</p>
<p><strong>Prozedur 8.6. Empfänger mittels Personenfilter selektieren</strong></p>
<ol>
<li>
<p>Personenfilter definieren</p>
<p>Für den Versand müssen die Empfänger vorgängig in einem Personenfilter selektiert werden.</p>
</li>
<li>
<p>Personenfilter markieren</p>
<p>Der definierte Personenfilter muss vorgängig markiert sein.</p>
</li>
<li>
<p>Ereignis und Ereignisposition erfassen</p>
<p>Die Empfänger erhalten ein Ereignis für den Versand, dieser muss vorgängig erfasst sein.</p>
</li>
<li>
<p>Personenfilter auswählen</p>
<p>Vorgängig definierten Filter auswählen</p>
</li>
<li>
<p>Ereignis auswählen</p>
<p>Vorgängig definiertes Ereignis auswählen</p>
</li>
<li>
<p>Ereignisposition auswählen</p>
<p>Vorgängig definierte Ereignisposition auswählen</p>
</li>
<li>
<p>Ereignisstatus auswählen</p>
<p>In der Regel wird dafür der Status Initial verwendet</p>
</li>
<li>
<p>Kampagne senden</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.kampagnesenden.html" title="Kampagne senden">Kampagne senden...</RouteLink> wählen. Die Kampagne kann nun durch die Auswahl &quot;definitiv&quot; an die selektierten Empfänger versendet werden oder durch die Auswahl &quot;Test&quot; zu Testzwecken an eine beliebige E-Mail Adresse geschickt werden.</p>
</li>
</ol>
<p><strong>Prozedur 8.7. Empfänger mittels Segmentierung selektieren</strong></p>
<ol>
<li>
<p>Segmentierung definieren</p>
<p>Für den Versand müssen die Empfänger vorgängig in einer Segmentierung selektiert werden.</p>
</li>
<li>
<p>Segmentierung markieren, Ereignisse definieren/verknüpfen und Exportdateien eintragen</p>
<p>Die definierte Segmentierung muss vorgängig markiert sein. Die verwendeten Segmente müssen ein Ereignis und eine Exportdatei eingetragen haben und die Ereignisse müssen verknüpft sein.</p>
</li>
<li>
<p>Segmentierung auswählen</p>
<p>Vorgängig definierte Segmentierung auswählen</p>
</li>
<li>
<p>Kampagne senden</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.kampagnesenden.html" title="Kampagne senden">Kampagne senden...</RouteLink> wählen. Die Kampagne kann nun durch die Auswahl &quot;definitiv&quot; an die selektierten Empfänger versendet werden oder durch die Auswahl &quot;Test&quot; zu Testzwecken an eine beliebige E-Mail Adresse geschickt werden.</p>
</li>
</ol>
<h3 id="_6-3-siehe-auch" tabindex="-1"><a class="header-anchor" href="#_6-3-siehe-auch"><span>6.3. Siehe auch</span></a></h3>
<p><RouteLink to="/referenz/refs/ft.refdata.mailchimp.html" title="MailChimp">MailChimp</RouteLink></p>
</div></template>


